'use client'

import { useEffect, useState } from 'react'

type Zxcvbn = (password: string) => { score: number }

/**
 * The zxcvbn score of `password`: 0 is too guessable, 4 very unguessable. Null until zxcvbn has
 * loaded: it is large, so it only loads once a form needs it.
 */
export function usePasswordScore(password: string): number | null {
    const [zxcvbn, setZxcvbn] = useState<Zxcvbn | null>(null)

    useEffect(() => {
        let isMounted = true
        import('zxcvbn').then(({ default: zxcvbn }) => {
            if (isMounted) {
                setZxcvbn(() => zxcvbn)
            }
        })

        return () => {
            isMounted = false
        }
    }, [])

    return zxcvbn ? zxcvbn(password).score : null
}
